<template lang="html">
  <div :class="outerContainerClass" v-if="isReady">
    <label :class="labelClass">
      {{ nameText }}
    </label>
    <div :class="valueContainerClass">
      <div class="slds-form-element__control">
        <text-input
          v-model="name"
          type="text"
          :focus="shouldFocus"
          @on-text-input-change="onNameChanged"
        />
        <div class="invalid-name-error" v-if="shouldShowError">
          {{ invalidNameText }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from "vuex";
  import TextInput from "@/components/TextInput";
  import utils from "@/utils";

  export default {
    name: "NameInput",
    components: {
      TextInput
    },
    props: {
      outerContainerClass: {
        type: String,
        default: "crm-fields-container"
      },
      labelClass: {
        type: String,
        default: "query-label query-object"
      },
      valueContainerClass: {
        type: String,
        default: "obj-select"
      },
      name: {
        type: String
      },
      isReady: {
        type: Boolean
      },
      shouldFocus: {
        type: Boolean
      },
      allDes: {
        type: Object
      },
      deId: {
        type: String
      }
    },
    computed: {
      ...mapState({
        messages: "messages"
      }),
      nameText() {
        return this.getMessageText(this.messages.NAME);
      },
      invalidNameText() {
        return this.getMessageText(this.messages.INVALID_NAME);
      },
      shouldShowError() {
        return !this.isValidName;
      }
    },
    data() {
      return {
        isValidName: true
      };
    },
    mounted() {
      this.onNameChanged(this.name);
    },
    methods: {
      onNameChanged(input) {
        this.isValidName = utils.validateName(input, this.deId, this.allDes);
        this.$emit("on-name-input-changed", this.isValidName, input);
      }
    }
  };
</script>

<style scoped></style>
